package com.ustadmobile.core.account

data class ClientId(val id: Int)